import React from "react";
import { Modal } from "@mui/material";
import { XIcon } from "@heroicons/react/solid";
import spinner from "../assets/images/spinner.gif";

const LeaveEncashmentModal = ({
  isOpen,
  onClose,
  formData,
  onChange,
  onSubmit,
  isEditing,
  isLoading,
  isEditLoading,
  errors,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="leave-encashment-modal"
    >
      <div className="w-[60%] bg-white absolute left-1/2 -translate-x-1/2 top-[20%] rounded-lg shadow-lg">
        <div className="px-6 py-4 divide-y">
          <div className="py-4">
            <div className="flex items-center justify-between">
              <h3 className="text-gray-700 text-2xl font-semibold">
                {isEditing ? "Edit Leave Adjustment" : "Leave Adjustment"}
              </h3>
              <div className="w-6 h-6 cursor-pointer" onClick={onClose}>
                <XIcon className="text-black w-full h-full" />
              </div>
            </div>
          </div>

          {isEditLoading ? (
            <div className="py-8 flex justify-center">
              <img src={spinner} alt="Loading" className="w-12 h-12" />
            </div>
          ) : (
            <div className="py-4">
              <form onSubmit={onSubmit}>
                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Leave Adjustment Type
                  </label>
                  <select
                    name="encashment_type"
                    value={formData.encashment_type}
                    onChange={onChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    required
                  >
                    <option value="" disabled>
                      -Select Adjustment Type-
                    </option>
                    <option value="encashment">Leave Encashment</option>
                    <option value="others">Others</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Action
                  </label>
                  <select
                    name="encashment_action"
                    value={formData.encashment_action}
                    onChange={onChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    required
                  >
                    <option value="" disabled>
                      -Select Action-
                    </option>
                    <option value="ADD">Add</option>
                    <option value="SUB">Subtract</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Leave Adjustment Count
                  </label>
                  <input
                    type="number"
                    name="encashment_count"
                    value={formData.encashment_count}
                    onChange={onChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    required
                    placeholder="Enter count"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                {errors.encashment_count && errors.encashment_count !== "" && (
                  <p className="text-red-500 text-sm mb-5">
                    {errors.encashment_count}
                  </p>
                )}

                <div className="mb-4">
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Remarks
                  </label>
                  <textarea
                    name="remarks"
                    value={formData.remarks}
                    onChange={onChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    rows="3"
                    placeholder="Enter remarks (optional)"
                  />
                </div>

                <div className="flex items-center justify-end space-x-4 mt-6">
                  <button
                    type="button"
                    onClick={onClose}
                    className="py-2 px-4 rounded font-semibold border border-[color:var(--color1)]"
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-[color:var(--color1)] text-white py-2 px-4 rounded font-semibold flex items-center justify-center"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <img
                          src={spinner}
                          alt="Loading"
                          className="w-5 h-5 mr-2"
                        />
                        {isEditing ? "Updating..." : "Saving..."}
                      </>
                    ) : isEditing ? (
                      "Update"
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default LeaveEncashmentModal;
